<div class="LesitungEdit row" *ngIf="Entry && Entry != null">
  <div class="row">
    <div class="row">
      <div class="col edit">
        <div class="row">
          <div class="col">
            <AdminCard [Item]="Entry" HeaderText="Geräte Infos">
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="deviceID" [(ngModel)]="Entry.geraeteInfo.deviceID" required>
                    <label for="deviceID">Device ID</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="clipID" [(ngModel)]="Entry.geraeteInfo.clipID" required>
                    <label for="clipID">Clip ID</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="imei" [(ngModel)]="Entry.imei" required>
                    <label for="imei">Imei</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="seriennummer" [(ngModel)]="Entry.geraeteInfo.seriennummer" required>
                    <label for="seriennummer">Seriennummer</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <Date-Select LabelText="Inbetriebnahme" [(Date)]="Entry.geraeteInfo.inbetriebnahme"></Date-Select>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <Date-Select LabelText="Auserbetriebnahme" [(Date)]="Entry.geraeteInfo.auserbetriebnahme"></Date-Select>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <select class="form-select"
                            id="partner" required
                            [ngModel]="Entry.partner?.key" (ngModelChange)="onPartnerChange($event)">

                      <option *ngFor="let Entry of Partner" [ngValue]="Entry.key">
                        {{ Entry.stammdaten.name }}
                      </option>
                    </select>
                    <label for="partner">Partner</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-check mb-3">
                    <input name="leitstelleAngeschlossen" id="leitstelleAngeschlossen" class="form-check-input" type="checkbox"
                           [checked]="Entry.leitstelleAngeschlossen"
                           (change)="Entry.leitstelleAngeschlossen = !Entry.leitstelleAngeschlossen" />
                    <label for="leitstelleAngeschlossen" class="form-check-label">
                      Leitstelle Angeschlossen
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-check mb-3">
                    <input name="deactivated" id="deactivated" class="form-check-input" type="checkbox"
                           [checked]="Entry.deactivated"
                           (change)="Entry.deactivated = !Entry.deactivated" />
                    <label for="deactivated" class="form-check-label">Deactivated</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <select class="form-select"
                            id="eigentumsart"
                            [(ngModel)]="Entry.geraeteInfo.eigentumsart">

                      <option *ngFor="let Entry of EigentumsArten" [ngValue]="Entry.Key">
                        {{ Entry.Value }}
                      </option>
                    </select>
                    <label for="eigentumsart">Eigentumsart</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <select class="form-select"
                            id="geraeteStatus"
                            [(ngModel)]="Entry.geraeteInfo.geraeteStatus">

                      <option *ngFor="let Entry of Stati" [ngValue]="Entry.Key">
                        {{ Entry.Value }}
                      </option>
                    </select>
                    <label for="geraeteStatus">Status</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="letzterStatuswechsel" [(ngModel)]="Entry.geraeteInfo.letzterStatuswechsel" readonly disabled>
                    <label for="letzterStatuswechsel">Letzter Statuswechsel</label>
                  </div>
                </div>
              </div>
            </AdminCard>
          </div>
          <div class="col">
            <AdminCard [Item]="Entry" HeaderText="Modell Infos">
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <select class="form-select"
                            id="model"
                            [(ngModel)]="Entry.model">

                      <option *ngFor="let Entry of Modelle" [ngValue]="Entry">
                        {{ Entry.bezeichnung }}
                      </option>
                    </select>
                    <label for="model">Model</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <select class="form-select" disabled
                            id="geraeteTyp"
                            [ngModel]="Entry.model?.geraeteTyp">

                      <option *ngFor="let Entry of Typen" [ngValue]="Entry.Key">
                        {{ Entry.Value }}
                      </option>
                    </select>
                    <label for="geraeteTyp">geraeteTyp</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="bezeichnung" [ngModel]="Entry.model?.bezeichnung" readonly disabled>
                    <label for="bezeichnung">Bezeichnung</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="hersteller" [ngModel]="Entry.model?.hersteller" readonly disabled>
                    <label for="hersteller">Hersteller</label>
                  </div>
                </div>
              </div>
            </AdminCard>
            <AdminCard [Item]="Entry" HeaderText="Leitstelle">
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <select class="form-select"
                            id="leitsetlle" required
                            [(ngModel)]="Entry.leitsetlle.key">

                      <option *ngFor="let Entry of Leitstellen" [ngValue]="Entry.key">
                        {{ Entry.name }}
                      </option>
                    </select>
                    <label for="leitsetlle">Leitsetlle</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" id="technischeID" [(ngModel)]="Entry.technischeID">
                    <label for="technischeID">technischeID</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-check mb-3">
                    <input name="leitstelleAngeschlossen" id="leitstelleAngeschlossen" class="form-check-input" type="checkbox"
                           [checked]="Entry.leitstelleAngeschlossen"
                           (change)="Entry.leitstelleAngeschlossen = !Entry.leitstelleAngeschlossen" />
                    <label for="leitstelleAngeschlossen" class="form-check-label">
                      Leitstelle Angeschlossen
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="input-group mb-3">
                    <div class="form-floating">
                      <input type="number" class="form-control" step="0.01" min="0.01" id="leitstellenKostenMonatBrutto" placeholder="0.00" [(ngModel)]="Entry.leitsetlle.leitstellenKostenMonatBrutto" disabled readonly>
                      <label for="leitstellenKostenMonatBrutto">Leitstellen Kosten im Monat (Brutto)</label>
                    </div>
                    <span class="input-group-text" id="basic-addon2">€</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="input-group mb-3">
                    <div class="form-floating">
                      <input type="number" class="form-control" step="0.01" min="0.01" id="leitstellenKostenMonatNetto" placeholder="0.00" [(ngModel)]="Entry.leitsetlle.leitstellenKostenMonatNetto" disabled readonly>
                      <label for="leitstellenKostenMonatNetto">Leitstellen Kosten im Monat (Netto)</label>
                    </div>
                    <span class="input-group-text" id="basic-addon2">€</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="input-group mb-3">
                    <div class="form-floating">
                      <input type="text" class="form-control"  id="lastRegistration" value="{{Entry.lastRegistration | date:'dd.MM.yyyy'}}" disabled readonly>
                      <label for="lastRegistration">Zuletzt Angemeldet am</label>
                    </div>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="input-group mb-3">
                    <div class="form-floating">
                      <input type="text" class="form-control"  id="lastUnregistration" value="{{Entry.lastUnregistration | date:'dd.MM.yyyy'}}" disabled readonly>
                      <label for="lastRegistration">Zuletzt Abgemeldet am</label>
                    </div>

                  </div>
                </div>
              </div>
            </AdminCard>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <AdminCard [Item]="Entry" HeaderText="Historie"  >
              <DataGridView DataUrl="/Backend/Api/V2/GeraeteHistorie/ByDevice/{{Entry.key}}/List" KeyProperty="geraeteID" [UseUrlFilter]="false" >
                <DataGridViewColumn field="auftragsID" header="Auftrags DCO-ID" [DataType]="Types.Number"></DataGridViewColumn>
                <DataGridViewColumn field="versichertenNr" header="Versicherten Nr." [DataType]="Types.String"></DataGridViewColumn>
                <DataGridViewColumn field="vorname" header="Vorname" [DataType]="Types.String"></DataGridViewColumn>
                <DataGridViewColumn field="nachname" header="Nachname" [DataType]="Types.String"></DataGridViewColumn>
                <DataGridViewColumn field="datum" header="Datum" [DataType]="Types.Date" format="dd.MM.yyyy"></DataGridViewColumn>
                <DataGridViewColumn field="tauschDatum" header="austausch Datum" [DataType]="Types.Date" format="dd.MM.yyyy"></DataGridViewColumn>
                <DataGridViewColumn field="tracking" header="Tracking Nr." [DataType]="Types.String"></DataGridViewColumn>
                <DataGridViewColumn field="auftragsID" header="" [DataType]="Types.Number">
                  <ng-template #cell let-row>
                    <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(row)"></div>
                  </ng-template>
                </DataGridViewColumn>
              </DataGridView>
            </AdminCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row Button">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="SaveData()">Speichern</div>
  </div>
</div>
<ng-template #successTpl> Speichern erfolgreich! </ng-template>
